module.exports = "FloatingPeoplePicker are used to pick recipients but do not need a well or necessarily keep track of selected people\n"